import { render } from "./EditorMode.vue?vue&type=template&id=ad80aef2&scoped=true"
import script from "./EditorMode.vue?vue&type=script&lang=js"
export * from "./EditorMode.vue?vue&type=script&lang=js"

import "./EditorMode.vue?vue&type=style&index=0&id=ad80aef2&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\attituttu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad80aef2"]])

export default __exports__